export default __webpack_public_path__ + "static/media/winner-success.b53060b0.svg";